import { useState, useEffect } from "react";
import "./AskedQuestions.css";
import { AskedQuestionsTable } from "./AskedQuestionsTable";
import { useLocation, useParams } from "react-router-dom";
import ResponseList from "./ResponseList";
import { AIResponseSave, RecentAnswer } from "winslow-core";
import { useSelector } from "react-redux";
import {
  selectEditingCollection,
  selectUser,
} from "../../redux/features/appData";
import {
  apiAIGetResponseSavesVisibleToUserInWorkspace,
  apiGetRecentAnswersVisibleToUserInWorkspace,
  apiGetUserRecentAnswers,
} from "../../services/AIService";
import { CollectionResourcesZero } from "./CollectionResourcesZero";
import { AskedQuestionsZero } from "./AskedQuestionsZero";

export const AskedQuestions = () => {
  const { userId } = useParams();

  const storeUser = useSelector(selectUser);
  const currentCollection = useSelector(selectEditingCollection);

  const [responses, setResponses] = useState<RecentAnswer[] | null>(null);

  useEffect(() => {
    (async () => {
      if (
        storeUser &&
        storeUser.currentWorkspaceId &&
        currentCollection &&
        userId
      ) {
        console.log("[AskedQuestions] loading questions for " + userId);
        let newResponses: RecentAnswer[] | null = null;

        // this is if we're getting all for a user
        if (userId !== "all") {
          newResponses = await apiGetUserRecentAnswers(
            userId,
            storeUser.currentWorkspaceId
          );
        } else {
          newResponses = await apiGetRecentAnswersVisibleToUserInWorkspace(
            storeUser.id,
            storeUser.currentWorkspaceId
          );
        }

        if (newResponses) {
          newResponses.sort((a: RecentAnswer, b: RecentAnswer) => {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          });

          setResponses([...newResponses]);
        }
      }
    })();
  }, [userId]);

  const collectionIsEmpty = currentCollection
    ? !(
        currentCollection.linkRecords &&
        currentCollection.linkRecords.length > 0
      )
    : true;

  console.log("[AskedQuestions] collectionisempty: ", collectionIsEmpty);

  console.log("[AskedQuestions] responses: ", responses);

  return (
    <div id="asked-questions">
      <div className="page-title">
        {userId === "all" ? "All Questions" : "Recently Asked"}
      </div>

      {collectionIsEmpty && (!responses || responses.length < 1) && (
        <div className="asked-questions-zero">
          <CollectionResourcesZero />
        </div>
      )}

      {!collectionIsEmpty && responses && responses.length === 0 && (
        <div className="asked-questions-no-questions">
          <AskedQuestionsZero />
        </div>
      )}

      {responses && responses.length > 0 && (
        <div className="asked-questions-container">
          {responses && <ResponseList responses={responses} />}
        </div>
      )}
    </div>
  );
};
